import React, { useState, FC } from 'react';
import { StyledBox } from 'views/rebranded-module/GeoViewV2/components/MapAndFilter/MapAndFilter.styles';
import { ShowMapDialogSection } from 'views/rebranded-module/GeoViewV2/components';
import { Button } from '@mui/material';
import { RiMap2Line, RiEqualizerLine } from 'react-icons/ri';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const MapAndFilter:FC<any> = (props) => {
  const {
    mapLocations,
    selectedPlace,
    handleFilterDialogOpen,
    handleBikeCardClick,
    isWigetOpen,
    handleMapChange,
    renderSkeleton,
    currentFilterParams,
    // "Search this area" props — received from GeoViewV2 and forwarded to
    // ShowMapDialogSection -> MapSection for the mobile fullscreen map flow.
    unsearchedMapBounds,
    onSearchThisArea,
    isMapLoading,
    handleMapLoadingFlag,
  } = props;
  const cmsData = useContent('GeoPage');
  const [showMap, setShowMap] = useState(false);
  const handleOpenShowMap = () => {
    setShowMap(true);
  };
  const handleCloseShowMapDialog = () => {
    setShowMap(false);
  };
  return (
    <>
      <StyledBox>
        <Button
          className='MFBtn'
          variant="contained"
          color="secondary"
          endIcon={<RiMap2Line />}
          onClick={handleOpenShowMap}>
          {cmsData.showMapLabel}
        </Button>
        <Button
          className='MFBtn'
          variant="contained"
          color="primary"
          startIcon={<RiEqualizerLine />}
          onClick={handleFilterDialogOpen}>
           {cmsData.filterLabel}
        </Button>
      </StyledBox>
      {showMap && (
        <ShowMapDialogSection
          open={showMap}
          mapLocations={mapLocations}
          selectedPlace={selectedPlace}
          handleClose={handleCloseShowMapDialog}
          handleBikeCardClick={handleBikeCardClick}
          isWigetOpen={isWigetOpen}
          handleMapChange={handleMapChange}
          renderSkeleton={renderSkeleton}
          currentFilterParams={currentFilterParams}
          // Forward "Search this area" state to the fullscreen map dialog
          unsearchedMapBounds={unsearchedMapBounds}
          onSearchThisArea={onSearchThisArea}
          isMapLoading={isMapLoading}
          handleMapLoadingFlag={handleMapLoadingFlag}
        />
      )}
    </>
  );
};

export { MapAndFilter };
